<script>
export default {
	name: 'cookie-blocker',
	props: {
		types: {
			type: [Array, String],
			default() {
				return [
					'functional',
					'statistic',
					'marketing',
				];
			},
		},
	},
	data() {
		return {
			currentConsent: {
				functional: null,
				statistic: null,
				marketing: null,
			},
		};
	},
	computed: {
		missingCookies() {
			let cookies = this.types;
			if (typeof cookies === 'string' || cookies instanceof String) {
				cookies = [cookies];
			}
			return cookies.filter(cookie => !this.currentConsent[cookie]);
		},
		mappedMissingCookies() {
			// Simply for translations and prettyfications of the words
			return this.missingCookies.map((cookie) => {
				switch (cookie) {
				case 'functional': return 'Funktionelle';
				case 'statistic': return 'Statistiske';
				case 'marketing': return 'Marketing';
				default: return cookie;
				}
			});
		},
	},
	mounted() {
		if (typeof window.CookieInformation !== "undefined") {
			this.currentConsent.functional = window.CookieInformation.getConsentGivenFor('cookie_cat_functional') || false;
			this.currentConsent.statistic = window.CookieInformation.getConsentGivenFor('cookie_cat_statistic') || false;
			this.currentConsent.marketing = window.CookieInformation.getConsentGivenFor('cookie_cat_marketing') || false;
		}
		// This event tells us when cookie consent has been updated
		window.addEventListener('CookieInformationConsentGiven', this.updateConsents);
	},
	destroyed() {
		window.removeEventListener('CookieInformationConsentGiven', this.updateConsents);
	},
	methods: {
		openCookieBanner() {
			if (typeof window !== 'undefined' && window.CookieConsent && window.CookieConsent.show) {
				window.CookieConsent.show();
				window.toggleDetails('coiShowDetails');
			} else {
				// The cookie banner does not work on localhost
				console.log('The button has been triggered, but the banner cannot be shown currently.');
			}
		},
		updateConsents() {
			if (typeof window.CookieInformation !== "undefined") {
				this.currentConsent = {
					functional: window.CookieInformation.getConsentGivenFor('cookie_cat_functional') || false,
					statistic: window.CookieInformation.getConsentGivenFor('cookie_cat_statistic') || false,
					marketing: window.CookieInformation.getConsentGivenFor('cookie_cat_marketing') || false,
				};
			}
		},
	},
};
</script>

<template src="./cookie-blocker.html"></template>
<style src="./cookie-blocker.scss"></style>


// WEBPACK FOOTER //
// cookie-blocker.vue?337c2bb6